import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { PageContainer } from "Shared/Components/Container";
import type { FC } from "react";
import { UserRoleCard } from "../../Components/UserRoles/UserRoleCard";

export enum UserRolesContentType {
	Edit = "edit",
	Add = "add",
	Default = "default",
}

type Props = {
	currentContent: UserRolesContentType;
};

const userResource = Resources.base.user.roles;

export const UserRoles: FC<Props> = ({ currentContent }) => {
	const { t } = useResource();
	return (
		<PageContainer
			title={t(userResource.title)}
			description={t(userResource.description)}
		>
			<UserRoleCard currentContent={currentContent} />
		</PageContainer>
	);
};
